import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { StringField } from '../../util/components/resource/resource-fields/resource-fields';

@Endpoint('skillz', 'Skillz')
export class Skillz extends ApiResource<Skillz> {
  @StringField({ label: $localize`Name` })
  name!: string;

  @StringField({ label: $localize`Description` })
  description!: string;
}
